import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber1 = () => {
  return (
    <g>
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.8181 7.8181 7.818 7.818 0 0 0 -7.8181-7.8181zm.9717 11.631h-1.4375v-6.2099l-1.7242.4258v-1.2764l3.1621-.7481z" />
    </g>
  );
};

export default withIcon(IconNumber1);
